const TRACKING_PARAM_KEYS = [
	"platform",
	"campaign_id",
	"campaignId",
	"campaign_type",
	"utm_campaign",
	"utm_source",
	"utm_medium",
	"utm_term",
	"utm_content",
	"ad_id",
	"adId",
	"gclid",
	"fbclid",
];

export const getTrackingParamsFromUrl = (): Record<string, string> => {
	if (typeof window === "undefined") return {};
	const params = new URLSearchParams(window.location.search);
	const trackingParams: Record<string, string> = {};
	params.forEach((value, key) => {
		if (TRACKING_PARAM_KEYS.includes(key) || key.startsWith("utm_")) {
			trackingParams[key] = value;
		}
	});
	if (params.get("campaignId") && !trackingParams.campaign_id) {
		trackingParams.campaign_id = params.get("campaignId")!;
	}
	if (params.get("adId") && !trackingParams.ad_id) {
		trackingParams.ad_id = params.get("adId")!;
	}
	return trackingParams;
};

export const storeTrackingParams = () => {
	if (typeof window === "undefined") return;
	const params = getTrackingParamsFromUrl();
	if (Object.keys(params).length > 0) {
		try {
			// Save in sessionStorage
			const existingSession = window.sessionStorage.getItem("edvia_utm_params");
			const existingSessionParams = existingSession ? JSON.parse(existingSession) : {};
			const mergedSession = { ...existingSessionParams, ...params };
			window.sessionStorage.setItem("edvia_utm_params", JSON.stringify(mergedSession));

			// Save in localStorage
			const existingLocal = window.localStorage.getItem("edvia_utm_params");
			const existingLocalParams = existingLocal ? JSON.parse(existingLocal) : {};
			const mergedLocal = { ...existingLocalParams, ...params };
			window.localStorage.setItem("edvia_utm_params", JSON.stringify(mergedLocal));
		} catch (e) {
			console.error("Failed to store tracking params", e);
		}
	}
};

export const getStoredTrackingParams = (): Record<string, string> => {
	if (typeof window === "undefined") return {};
	try {
		const sessionSaved = window.sessionStorage.getItem("edvia_utm_params");
		if (sessionSaved) return JSON.parse(sessionSaved);
		
		const localSaved = window.localStorage.getItem("edvia_utm_params");
		if (localSaved) return JSON.parse(localSaved);
	} catch (e) {
		console.error("Failed to get stored tracking params", e);
	}
	return {};
};
